const totalLabels = {
  /**
   * 合計値ラベルを描画
   */
  afterDatasetsDraw(chart) {
    let ctx = chart.ctx;
    // ラベルの書式設定
    ctx = this.setTextStyle(ctx);
    // 各棒最後の項目のメタ情報を取得
    const meta = this.getLastMeta(chart);
    // 各合計値を取得
    const sums = this.calcSums(chart.data.datasets);
    // // ラベル描画
    const labels = this.makeLabels(meta, sums);
    labels.forEach(function (label) {
      ctx.fillText(label.value, label.x, label.y);
    });
  },

  /**
   * 各項目の合計を取得
   */
  calcSums(datasets) {
    const sums = [];
    datasets.forEach(function (dataset) {
      // 非表示の項目は処理しない
      // if (dataset._meta[0].hidden) {
      //   return;
      // }
      dataset.data.forEach(function (value, i) {
        if (typeof sums[i] === "undefined") {
          sums[i] = 0;
        }
        sums[i] += value;
      });
    });
    return sums;
  },

  /**
   * 各棒最後の項目のメタ情報を取得
   * (非表示のものは除く)
   */
  getLastMeta(chart) {
    let i = chart.data.datasets.length - 1;
    let meta = undefined;
    do {
      meta = chart.getDatasetMeta(i);
      i--;
    } while (meta.hidden && i >= 0);

    return meta;
  },

  /**
   * ラベル情報を取得
   */
  makeLabels(meta, sums) {
    const labels = [];
    sums.forEach(function (sum, i) {
      const lastModel = meta.data[i]._model;
      labels.push({
        value: sum.toString().toLocaleString(),
        x: lastModel.x + 5, // + 5 はグラフとラベルの間隔
        y: lastModel.y,
      });
    });

    return labels;
  },

  /**
   * 書式設定
   */
  setTextStyle(ctx) {
    const fontSize = 12;
    const fontStyle = 'bold';
    const fontFamily = "roboto";
    ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
    ctx.fillStyle = "#5a5a5a";
    ctx.textAlign = "left";
    ctx.textBaseline = "middle";

    return ctx;
  }
};
export default {
  totalLabels
}



// WEBPACK FOOTER //
// ./src/plugins/chartjs-plugin-total-labels.js